import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { Query2hw717wsl0l5r as Query } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Query.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NetworkInterceptorClass;
function NetworkInterceptor() {
  if (NetworkInterceptorClass === VOID) {
    class $ {
      constructor(networkTransport, subscriptionNetworkTransport) {
        this.t6b_1 = networkTransport;
        this.u6b_1 = subscriptionNetworkTransport;
      }
      s6b(request, chain) {
        var tmp0_subject = request.r44_1;
        var tmp;
        if (isInterface(tmp0_subject, Query())) {
          tmp = this.t6b_1.v6b(request);
        } else {
          if (isInterface(tmp0_subject, Mutation())) {
            tmp = this.t6b_1.v6b(request);
          } else {
            if (isInterface(tmp0_subject, Subscription())) {
              tmp = this.u6b_1.v6b(request);
            } else {
              // Inline function 'kotlin.error' call
              throw IllegalStateException().o(toString(''));
            }
          }
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'NetworkInterceptor');
    NetworkInterceptorClass = $;
  }
  return NetworkInterceptorClass;
}
//region block: exports
export {
  NetworkInterceptor as NetworkInterceptor22fszyorwx7pt,
};
//endregion

//# sourceMappingURL=NetworkInterceptor.mjs.map
